import React from 'react';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';

const propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

function FeatureCard({ icon, title, description }) {
  return (
    <Col md={6} className="remove-padding">
      <div className="big-and-mini-card-left">{icon}</div>
      <div className="big-and-mini-card-right">

        <h3>
          {title}
        </h3>
        {description}
        {/* <a href = "signup" className = "underline">
                                Sign Up as a Big
                            </a> */}
      </div>

    </Col>
  );
}

FeatureCard.propTypes = propTypes;
export default FeatureCard;
